import utils from "../../../utils/utils.js";

export default {
  async fetchEngagementFeederTypes(context, payload) {
    const pageNumber = payload.pageNumber;
    const pageSize = payload.pageSize;
    const sortColumn = payload.sortColumn;
    const sortDirection = payload.sortDirection;
    const searchText = payload.searchText;

    const responseData = await utils.utility.fetch(
      `api/Setting/GetEngagementFeederTypes?pageNumber=${pageNumber}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&searchText=${searchText}`,
      "GET",
      null,
      null
    );
    context.commit("setEngagementFeederTypes", responseData.data);
  },

  async postEngagementFeederType(context, payload) {
    await utils.utility.fetch(
      `api/Setting/CreateEngagementFeederType`,
      "POST",
      null,
      payload
    );
  },
  async putEngagementFeederType(context, payload) {
    await utils.utility.fetch(
      `api/Setting/UpdateEngagementFeederType`,
      "PUT",
      null,
      payload
    );
  },

  async deleteEngagementFeederType(context, payload) {
    let postData = { id: payload.id };
    await utils.utility.fetch(
      `api/Setting/DeleteEngagementFeederType`,
      "POST",
      null,
      postData
    );
  },
};
